import type { ProntuarioSessionChoiceValue } from '../../constants/prontuarioSessionChoices';
import type {
	ProntuarioPastSessionFieldDefinition,
	ProntuarioPastSessionRecord,
} from '../../types/prontuarioPastSession';
import { PbtsTagChips } from '@/components/pbts/PbtsTagChips';
import {
	ProntuarioReadonlyChoiceField,
	ProntuarioReadonlyField,
} from '../SessionCallProntuarioFields';

const PAST_SESSION_TAG_FIELD_BY_KEY: Partial<
	Record<
		ProntuarioPastSessionFieldDefinition['key'],
		keyof ProntuarioPastSessionRecord
	>
> = {
	humorObservado: 'humorObservadoTag',
	queixasSecundarias: 'queixasSecundariasTag',
	conteudoTecnicas: 'conteudoTecnicasTag',
	evolucaoObservacoes: 'evolucaoObservacoesTag',
	observacoesRisco: 'observacoesRiscoTag',
};

type ProntuarioPastSessionFieldProps = {
	record: ProntuarioPastSessionRecord;
	field: ProntuarioPastSessionFieldDefinition;
};

const ProntuarioPastSessionField = ({
	record,
	field,
}: ProntuarioPastSessionFieldProps) => {
	const rawValue = record[field.key];
	const tagKey = PAST_SESSION_TAG_FIELD_BY_KEY[field.key];
	const tagValue = tagKey ? record[tagKey] : undefined;

	if (field.kind !== 'text') {
		return (
			<ProntuarioReadonlyChoiceField
				label={field.label}
				value={rawValue as ProntuarioSessionChoiceValue}
				kind={field.kind}
				fullWidth={field.fullWidth}
				appearance="material"
			/>
		);
	}

	return (
		<div className={field.fullWidth ? 'sm:col-span-2' : undefined}>
			<ProntuarioReadonlyField
				label={field.label}
				value={String(rawValue).trim()}
				fullWidth={field.fullWidth}
				appearance="material"
			/>
			{typeof tagValue === 'string' && tagValue.trim() ? (
				<PbtsTagChips value={tagValue} className="mt-2" />
			) : null}
		</div>
	);
};

export { ProntuarioPastSessionField };
